import { render, staticRenderFns } from "./SalesSummary.vue?vue&type=template&id=a570f22c&"
import script from "./SalesSummary.vue?vue&type=script&lang=js&"
export * from "./SalesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports